var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, useCallback } from 'react';
import { PaperPlaneRightIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
export function ChatInput(_a) {
    var { onSend, className, disabled, placeholder = 'Type something...' } = _a, props = __rest(_a, ["onSend", "className", "disabled", "placeholder"]);
    const textareaRef = useRef(null);
    const [message, setMessage] = useState('');
    const handleSubmit = (e) => {
        var _a;
        e.preventDefault();
        (_a = props.onSubmit) === null || _a === void 0 ? void 0 : _a.call(props, e);
        onSend === null || onSend === void 0 ? void 0 : onSend(message);
        setMessage('');
        // Reset textarea height after sending
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }
    };
    const isDisabled = disabled || message.trim().length === 0;
    // Auto-resize textarea
    const adjustHeight = useCallback(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`;
        }
    }, []);
    useEffect(() => {
        adjustHeight();
    }, [message, adjustHeight]);
    useEffect(() => {
        var _a;
        if (disabled) {
            return;
        }
        // when not disabled refocus on textarea
        (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [disabled]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!isDisabled) {
                onSend === null || onSend === void 0 ? void 0 : onSend(message);
                setMessage('');
                if (textareaRef.current) {
                    textareaRef.current.style.height = 'auto';
                }
            }
        }
    };
    return (_jsxs("form", Object.assign({}, props, { onSubmit: handleSubmit, className: cn('flex items-center rounded-2xl border border-gray-200 bg-gray-50 pl-4 pr-2 py-1 shadow-sm transition-all focus-within:border-gray-300 focus-within:bg-white focus-within:shadow', className), children: [_jsx("textarea", { autoFocus: true, ref: textareaRef, value: message, disabled: disabled, placeholder: placeholder, onChange: (e) => setMessage(e.target.value), onKeyDown: handleKeyDown, rows: 1, className: "flex-1 resize-none bg-transparent py-2.5 text-[14px] text-gray-900 placeholder:text-gray-500 outline-none disabled:cursor-not-allowed disabled:opacity-50", style: { minHeight: '20px', maxHeight: '120px' } }), _jsx(Button, { size: "icon", type: "submit", disabled: isDisabled, className: cn('ml-2 h-9 w-9 shrink-0 rounded-xl transition-all active:scale-95', isDisabled
                    ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                    : 'bg-indigo-600 text-white hover:bg-indigo-700'), children: _jsx(PaperPlaneRightIcon, { weight: "bold", size: 16 }) })] })));
}
